"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Files = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var atoms_1 = require("../../atoms");
require("react-multi-carousel/lib/styles.css");
exports.Files = react_1.default.memo(function (_a) {
    var _b = _a.attachmentList, attachmentList = _b === void 0 ? [] : _b, deleteHandler = _a.deleteHandler;
    return ((0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ container: true, spacing: 2 }, { children: attachmentList.map(function (item) {
            var itemName = item.name || item.file.name;
            var itemType = item.type || item.file.type;
            return ((0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ item: true, xs: 3 }, { children: (0, jsx_runtime_1.jsx)(atoms_1.IconChip, { fileName: itemName, chipText: itemName, fileType: itemType, onRemove: function () { return deleteHandler(itemName, 'name'); } }) }), itemName));
        }) })));
});
